( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('ContractDTOCustomService', ContractDTOCustomService);

    ContractDTOCustomService.$inject = ['$http'];

    function ContractDTOCustomService($http) {
        return {
            getShipments: getShipments,
            getLots: getLots,
            getInvoices: getInvoices
        };

        function getShipments(id) {
            var url = "api/contractDTO/" + id + "/shipments";
            return $http.get(url);
        }

        function getLots(id) {
            var url = "api/contractDTO/" + id + "/lots";
            return $http.get(url);
        }

        function getInvoices(id) {
            var url = "api/contractDTO/" + id + "/invoices";
            return $http.get(url);
        }
    }
})();
